/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import logger from 'redux-logger'

import claveReducer from './features/clave.redux'
import formReducer from './features/form.redux'
import dataModelsReducer from './features/data-models.redux'
import storefrontReducer from './features/storefront.redux'
import dataStorageReducer from './features/data-storage.redux'
import tokenReducer from './features/token.redux'

interface WindowWithReduxDevtools extends Window {
  __REDUX_DEVTOOLS_EXTENSION__?: () => <T>(arg: T) => T
}

const reducer = combineReducers({
  clave: claveReducer,
  form: formReducer,
  dataModel: dataModelsReducer,
  storefront: storefrontReducer,
  dataStorage: dataStorageReducer,
  token: tokenReducer,
})

const appWindow = window as WindowWithReduxDevtools

const store = createStore(
  reducer,
  {},
  process.env.REACT_APP_WEBSITE_STAGE.toLowerCase() === 'dev'
    ? compose(
        applyMiddleware(logger),
        appWindow.__REDUX_DEVTOOLS_EXTENSION__
          ? appWindow.__REDUX_DEVTOOLS_EXTENSION__()
          : (f) => f,
      )
    : appWindow.__REDUX_DEVTOOLS_EXTENSION__
      ? appWindow.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f,
)

export { store }
